"use strict";
/**
 * Duplicated types from editor-platform-private-api / HostAPIBase.ts
 * to allow use them in public packages
 */
Object.defineProperty(exports, "__esModule", { value: true });
